module.exports = __webpack_public_path__ + "static/img/banner_.79b045c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_.png
// module id = fdMV
// module chunks = 18